// Loader.js
import React from 'react';
import { BallTriangle } from 'react-loader-spinner';
import './css/loader.css';

const Loader = () => {
  return (
    <div className="loader-overlay">
      <BallTriangle 
        height={100} 
        width={100} 
        color="#50CD89" 
        ariaLabel="loading" 
      />
    </div>
  );
};

export default Loader;
